import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export default function ParticleBackground({ starCount = 40, particleCount = 20 }) {
  // Memoize star positions
  const stars = useMemo(() =>
    Array.from({ length: starCount }, (_, i) => ({
      id: `star-${i}`,
      left: Math.random() * 100,
      top: Math.random() * 100,
      duration: 2 + Math.random() * 3,
      delay: Math.random() * 2,
    })), [starCount]
  );

  // Memoize particle positions
  const particles = useMemo(() =>
    Array.from({ length: particleCount }, (_, i) => ({
      id: `particle-${i}`,
      left: Math.random() * 100,
      top: Math.random() * 100,
      duration: 4 + Math.random() * 4,
      delay: Math.random() * 2,
      emoji: ['✨', '🌙', '⭐', '💫', '🔮'][i % 5],
    })), [particleCount]
  );

  return (
    <div className="fixed inset-0 pointer-events-none">
      {/* Stars */}
      {stars.map((star) => (
        <motion.div
          key={star.id}
          className="absolute w-1 h-1 bg-amber-300 rounded-full"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
          }}
          animate={{
            opacity: [0.2, 1, 0.2],
            scale: [0.8, 1.2, 0.8],
          }}
          transition={{
            duration: star.duration,
            repeat: Infinity,
            delay: star.delay,
          }}
        />
      ))}

      {/* Floating mystical particles */}
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          className="absolute text-2xl opacity-30"
          style={{
            left: `${particle.left}%`,
            top: `${particle.top}%`,
          }}
          animate={{
            y: [-30, 30, -30],
            x: [-20, 20, -20],
            rotate: [0, 180, 360],
            opacity: [0.2, 0.6, 0.2],
          }}
          transition={{
            duration: particle.duration,
            repeat: Infinity,
            delay: particle.delay,
            ease: 'easeInOut',
          }}
        >
          {particle.emoji}
        </motion.div>
      ))}
    </div>
  );
}
